
export default {
  name: 'SecurityBadges',
  components: {},
  props: {
    blok: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      hideMobile: this.blok.hideMobile
    }
  },
  computed: {
    brandImg() {
      return this.$config.brand === 'PHA'
        ? 'https://honesteonline.com/HEOSealsNewNoDate/heosealimg.php?company=15395&link=10677'
        : 'https://honesteonline.com/HEOSealsNewNoDate/heosealimg.php?company=16492&link=10983'
    },
    brandLink() {
      return this.$config.brand === 'PHA'
        ? 'https://honesteonline.com/members/consumerpage.php?company=15395&link=10677'
        : 'https://honesteonline.com/members/consumerpage.php?company=16492&link=10983'
    }
  }
}
